import { useRef, useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { cn } from '@/lib/utils'
import { useRestTimer } from '@/stores/rest-timer'
import { PauseIcon, PlayIcon, X as XMarkIcon } from 'lucide-react'
import formatDuration from 'format-duration'
import { Collapsible, CollapsibleContent } from './ui/collapsible'

export function RestTimer({ className }: { className?: string }) {
  const isOpen = useRestTimer(useShallow((s) => !!s.startTime))
  const isRunning = useRestTimer(useShallow((s) => s.isRunning))
  const actions = useRestTimer(
    useShallow((s) => ({
      pause: s.pause,
      stop: s.stop,
      start: s.start,
    }))
  )
  const spanRef = useRef<HTMLSpanElement>(null)

  const notificationRef = useRef<Notification>(null)

  useEffect(() => {
    const unsub = useRestTimer.subscribe((s) => {
      if (spanRef.current) {
        const formattedDuration = formatDuration(s.milliseconds)
        spanRef.current.innerText = formattedDuration

        // const isRoundMinute = s.milliseconds % 60000 === 0
        // if (
        // 	'Notification' in window &&
        // 	document.visibilityState === 'hidden' &&
        // 	isRoundMinute
        // ) {
        // 	Notification.requestPermission().then((permission) => {
        // 		if (permission === 'granted') {
        // 			navigator.serviceWorker.ready.then((registration) => {
        // 				registration.showNotification('Rest Timer', {
        // 					body: formattedDuration,
        // 					tag: 'liftkit-timer',
        // 					renotify: true,
        // 					silent: true,
        // 					icon,
        // 					badge,
        // 				})
        // 			})
        // 		}
        // 	})
        // } else if (
        // 	document.visibilityState === 'visible' &&
        // 	notificationRef.current
        // ) {
        // 	notificationRef.current.close()
        // }
      }
    })

    return () => {
      unsub()

      if (notificationRef.current) {
        notificationRef.current.close()
      }
    }
  }, [spanRef.current])

  return (
    <Collapsible className={className} open={isOpen}>
      <CollapsibleContent
        asChild
        className={cn(
          'hstack pl-4 bg-stone-900 text-stone-50 collapsible-content-animate'
        )}
      >
        <div>
          <span
            ref={spanRef}
            className={cn(
              !isRunning && 'animate-pulse',
              'tabular-nums tracking-widest text-md font-semibold whitespace-nowrap'
            )}
          >
            0:00
          </span>
          <button
            className="p-3"
            onClick={(e) => {
              e.preventDefault()
              if (isRunning) {
                actions.pause()
              } else {
                actions.start()
              }
            }}
          >
            {isRunning ? (
              <PauseIcon className="w-8 h-8" />
            ) : (
              <PlayIcon className="w-8 h-8" />
            )}
          </button>
          <button
            className="p-3"
            onClick={(e) => {
              e.preventDefault()
              actions.stop()
            }}
          >
            <XMarkIcon className="w-8 h-8" />
          </button>
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
